import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../user.service';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-labs-page2',
  templateUrl: './labs-page2.component.html',
  styleUrls: ['./labs-page2.component.css']
})
export class LabsPage2Component implements OnInit {
  page = -1;
  accessKey = '';
  secretAccessKey = '';
  labState = {};
  lab2_sec_group = '';

	titleOptions = [
		'Intro',
		'Pre-requisites',
		'Create a Admin IAM User with full admin permissions. Login as that user for the rest of the lab.',
		'Create security group that allows SSH and HTTPS access',
		'Create a EC2 Instance using the Amazon AMI and install Apache with a hello world website. Access the site from the internet. Log into the the ec2 instance from your terminal using the generated ec2 SSH keys. Repeat this lab but create a bootstrap script to install apache, create the index.html file, and start apache without having to log into the box.',
	]


  constructor(public ngxSmartModalService: NgxSmartModalService,private userService: UserService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    console.log(this.activatedRoute.snapshot.paramMap.get("labNumber"))
    this.setPage( Number(this.activatedRoute.snapshot.paramMap.get("labNumber")));

    /*  */
    this.activatedRoute.paramMap.subscribe( params => {
      this.setPage( Number(params.get("labNumber") ) );
    });
  }
  setPage(num) {
    this.page = num;
  }
  sendKey() {
    if (this.accessKey.length == 0 || this.secretAccessKey.length == 0 ) {
      alert("Missing valid access key and secret access key.");
      return;
    }


    this.userService.user.secretAccessKey = this.secretAccessKey;
    this.userService.user.accessKey = this.accessKey;

    this.userService.createUser(this.userService.user).subscribe(
      res => {
        let pass = res['checks']["overallPass"]
        this.labState['lab1'] = pass;
        if (pass) {
          alert('You passed!!')
        } else {
          alert("You failed lab 1. Please try again.")
        }
      },
      err => {
        console.log("Error occured", err);
      }
    );

  }
  verifyLab2() {
    if (this.lab2_sec_group.length == 0 ) {
      alert("Missing security group")
    }

    this.userService.verifyLab2(this.lab2_sec_group).subscribe(
      res => {
        let pass = res['checks']["overallPass"]
        this.labState['lab1'] = pass;
        if (pass) {
          alert('You passed!!')
        } else {
          alert("You failed lab 2. Please try again.")
        }
      },
      err => {
        console.log("Error occured", err);
      }
    );

  }

  openPopup() {
    this.ngxSmartModalService.getModal('infoModal').open()
  }
}



// WEBPACK FOOTER //
// ./src/app/course/labs-page2/labs-page2.component.ts